export default {
  SHOP : 'SHOP'
};